import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import * as _ from 'lodash';

import { AideModel } from '../models/AideModel';
import { CacheService } from '../services/cache-service';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { PermissionService } from '../services/permission.service';

@Injectable()
export class AideService {
  constructor(
    private cacheService: CacheService,
    private permissionService: PermissionService,
  ) {}

  @Output() isDisplayEditAideChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() isDisplayAideChanged: EventEmitter<boolean> = new EventEmitter();

  getDisplayEditAideFromStorage(key: string) {
    return sessionStorage.getItem(key) == 'true' ? true : false;
  }

  private _displayEditAide: boolean = null;
  get displayEditAide(): boolean {
    if (this._displayEditAide == null) {
      this._displayEditAide = this.getDisplayEditAideFromStorage('displayEditAide');
    }
    return this._displayEditAide;
  }
  set displayEditAide(value: boolean) {
    this._displayEditAide = value;
    sessionStorage.setItem('displayEditAide', <string>(<any>value));
    if (value) {
      this.displayAide = true;
    }
    this.isDisplayEditAideChanged.emit(value);
  }

  private _displayAide: boolean = null;
  get displayAide(): boolean {
    if (this._displayAide == null) {
      this._displayAide = this.getDisplayEditAideFromStorage('displayAide') || true;
    }
    return this._displayAide;
  }
  set displayAide(value: boolean) {
    this._displayAide = value;
    sessionStorage.setItem('displayAide', <string>(<any>value));
    if (!value) {
      this.displayEditAide = false;
    }
    this.isDisplayAideChanged.emit(value);
  }

  isAdminAide(): boolean {
    return this.permissionService.hasAdministrateurPermission();
  }

  public SharedAide: any = {};

  private Pops: PopoverDirective[] = [];
  newPop(pop: PopoverDirective) {
    this.Pops.push(pop);
  }
  removePop(pop: PopoverDirective) {
    let index = this.Pops.indexOf(pop);
    if (index > -1) {
      this.Pops.splice(index, 1);
    }
  }
  clearPops() {
    const pops = [...this.Pops];
    this.Pops = [];
    _.forEach(pops, p => {
      p.hide();
    });
  }

  private aides: AideModel[] = null;

  getAide(code: string): Observable<AideModel> {
    if (this.aides == null) {
      return this.cacheService.getAides().pipe(
        share(),
        map(aides => {
          this.aides = aides;
          return _.find(this.aides, a => a.Code == code);
        }),
      );
    } else {
      return of(_.find(this.aides, a => a.Code == code));
    }
  }

  updateAide(aide: AideModel) {
    if (this.aides != null && aide) {
      var aideCache = _.find(this.aides, a => a.Code == aide.Code);
      if (aideCache != null) {
        aideCache.Aide = aide.Aide;
      } else {
        this.aides.push({ ...aide });
      }
    }
  }

  deleteAide(aide: AideModel) {
    if (this.aides != null && aide) {
      var aideCache = _.find(this.aides, a => a.Code == aide.Code);
      if (aideCache != null) {
        aideCache.Aide = null;
      }
    }
  }
}
